// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sunzi__related-record-product-IEHcY {
  z-index: 20;
}
.sunzi__related-record-product-drawer-AnOo8 {
  padding-top: 106px;
}
.sunzi__related-record-product-drawer-AnOo8 .sunzi__drawer-content-hnT8d {
  width: 100%;
  position: relative;
  background: #fff;
  padding: 106px 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}
.sunzi__related-record-product-drawer-AnOo8 .sunzi__drawer-content-hnT8d.sunzi__size-GyoTF {
  width: auto;
  border-radius: 4px;
  padding: 12px 20px;
  background-color: #fafafa;
  margin: 12px 16px;
}
.sunzi__related-record-product-drawer-AnOo8 .sunzi__drawer-content-hnT8d .sunzi__image-wrapper-IHVBl {
  position: absolute;
  left: calc((100% - 182px) / 2);
  top: -90px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  overflow: hidden;
  filter: drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.05));
  border-radius: 8px;
}
.sunzi__related-record-product-drawer-AnOo8 .sunzi__drawer-content-hnT8d .sunzi__image-wrapper-IHVBl .sunzi__image-hwg7t {
  width: 180px;
  height: 180px;
  background-size: cover;
  background-repeat: no-repeat;
  background-color: white;
}
.sunzi__related-record-product-drawer-AnOo8 .sunzi__drawer-content-hnT8d .sunzi__image-wrapper-IHVBl .sunzi__offer-vNBVZ {
  position: absolute;
  top: 0;
  right: 0;
  padding: 4px 8px;
  color: #d9492e;
  font-weight: bold;
  font-size: 12px;
  background: #ffdb21;
  border-radius: 0 8px 0 8px;
  border: 2px solid #fff;
}
.sunzi__related-record-product-drawer-AnOo8 .sunzi__drawer-content-hnT8d .sunzi__previous-qXjLn {
  display: flex;
  position: absolute;
  left: 0;
  top: 0;
  padding: 20px;
  cursor: pointer;
}
.sunzi__related-record-product-drawer-AnOo8 .sunzi__drawer-content-hnT8d .sunzi__title-sqYAj {
  padding: 0 25px;
  color: #000;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
}
.sunzi__related-record-product-drawer-AnOo8 .sunzi__drawer-content-hnT8d .sunzi__price-OzlrX {
  color: var(--sunzi-theme-color);
  font-size: 16px;
  font-weight: 700;
}
.sunzi__related-record-product-drawer-AnOo8 .sunzi__drawer-content-hnT8d .sunzi__tip-wrapper-tGZmL {
  margin: 0 16px;
}
.sunzi__related-record-product-drawer-AnOo8 .sunzi__drawer-content-hnT8d .sunzi__tip-wrapper-tGZmL .sunzi__tip-jf0NQ {
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  text-align: center;
  color: #000000;
}
.sunzi__related-record-product-drawer-AnOo8 .sunzi__drawer-content-hnT8d .sunzi__tip-wrapper-tGZmL .sunzi__tip-jf0NQ .sunzi__price1-ZD6jW {
  -webkit-text-decoration: line-through;
  text-decoration: line-through;
  margin-left: 5px;
}
.sunzi__related-record-product-drawer-AnOo8 .sunzi__drawer-content-hnT8d .sunzi__tip-wrapper-tGZmL .sunzi__tip-jf0NQ .sunzi__price2-_8TLN {
  color: var(--sunzi-theme-color);
  font-size: 20px;
  font-weight: bold;
  margin: 0 5px;
}
.sunzi__related-record-product-drawer-AnOo8 .sunzi__drawer-content-hnT8d .sunzi__select-wrapper-hLXFy {
  width: 100%;
}
.sunzi__related-record-product-drawer-AnOo8 .sunzi__drawer-content-hnT8d .sunzi__select-wrapper-hLXFy .sunzi__unselect-size-w3kxc img {
  opacity: 0.4;
  transition: opacity 0.2s;
}
.sunzi__related-record-product-drawer-AnOo8 .sunzi__drawer-content-hnT8d .sunzi__select-wrapper-hLXFy .sunzi__select-size-atSO0 img {
  opacity: 1;
}
.sunzi__related-record-product-drawer-AnOo8 .sunzi__drawer-content-hnT8d .sunzi__select-wrapper-hLXFy .sunzi__select-size-line-rxu52 {
  opacity: 0;
  background-color: var(--sunzi-theme-color);
  transition: opacity 0.2s;
}
.sunzi__related-record-product-drawer-AnOo8 .sunzi__drawer-content-hnT8d .sunzi__select-wrapper-hLXFy .sunzi__select-size-line-show-alf4C {
  opacity: 1;
}
.sunzi__related-record-product-drawer-AnOo8 .sunzi__drawer-content-hnT8d .sunzi__button-group-jep1l {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.sunzi__related-record-product-drawer-AnOo8 .sunzi__drawer-content-hnT8d .sunzi__button-group-jep1l .sunzi__disable-button-HVY4f {
  background: rgba(0, 0, 0, 0.16);
  pointer-events: none;
  touch-action: none;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/incementDrawer/Recorder/style.module.less"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AACE;EACE,kBAAA;AACJ;AAFE;EAII,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,4BAAA;EACA,6BAAA;AACN;AACM;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;AACR;AApBE;EAuBM,kBAAA;EACA,8BAAA;EACA,UAAA;EACA,qCAAA;EACA,gBAAA;EACA,oDAAA;EACA,kBAAA;AAAR;AA7BE;EAgCQ,YAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,uBAAA;AAAV;AApCE;EAwCQ,kBAAA;EACA,MAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,0BAAA;EACA,sBAAA;AADV;AAhDE;EAsDM,aAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,eAAA;AAHR;AAxDE;EA+DM,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAJR;AA/DE;EAuEM,+BAAA;EACA,eAAA;EACA,gBAAA;AALR;AApEE;EA6EM,cAAA;AANR;AAvEE;EA+EQ,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AALV;AA9EE;EAqFU,qCAAA;EAAA,6BAAA;EACA,gBAAA;AAJZ;AAlFE;EA0FU,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;AALZ;AAxFE;EAmGM,WAAA;AARR;AA3FE;EAsGU,YAAA;EACA,wBAAA;AARZ;AA/FE;EA4GU,UAAA;AAVZ;AAlGE;EAgHQ,UAAA;EACA,0CAAA;EACA,wBAAA;AAXV;AAvGE;EAqHQ,UAAA;AAXV;AA1GE;EA0HM,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAbR;AAhHE;EAgIQ,+BAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;AAbV","sourcesContent":[".related-record-product {\n  z-index: 20;\n\n  &-drawer {\n    padding-top: 106px;\n\n    .drawer-content {\n      width: 100%;\n      position: relative;\n      background: #fff;\n      padding: 106px 0 0;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      border-top-left-radius: 16px;\n      border-top-right-radius: 16px;\n\n      &.size {\n        width: auto;\n        border-radius: 4px;\n        padding: 12px 20px;\n        background-color: #fafafa;\n        margin: 12px 16px;\n      }\n\n      .image-wrapper {\n        position: absolute;\n        left: calc((100% - 182px) / 2);\n        top: -90px;\n        border: 1px solid rgba(0, 0, 0, 0.06);\n        overflow: hidden;\n        filter: drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.05));\n        border-radius: 8px;\n\n        .image {\n          width: 180px;\n          height: 180px;\n          background-size: cover;\n          background-repeat: no-repeat;\n          background-color: white;\n        }\n\n        .offer {\n          position: absolute;\n          top: 0;\n          right: 0;\n          padding: 4px 8px;\n          color: #d9492e;\n          font-weight: bold;\n          font-size: 12px;\n          background: #ffdb21;\n          border-radius: 0 8px 0 8px;\n          border: 2px solid #fff;\n        }\n      }\n\n      .previous {\n        display: flex;\n        position: absolute;\n        left: 0;\n        top: 0;\n        padding: 20px;\n        cursor: pointer;\n      }\n\n      .title {\n        padding: 0 25px;\n        color: #000;\n        font-size: 18px;\n        font-weight: 700;\n        text-align: center;\n      }\n\n      .price {\n        color: var(--sunzi-theme-color);\n        font-size: 16px;\n        font-weight: 700;\n      }\n\n      .tip-wrapper {\n        margin: 0 16px;\n        .tip {\n          font-size: 16px;\n          line-height: 24px;\n          font-weight: 500;\n          text-align: center;\n          color: #000000;\n          .price1 {\n            text-decoration: line-through;\n            margin-left: 5px;\n          }\n\n          .price2 {\n            color: var(--sunzi-theme-color);\n            font-size: 20px;\n            font-weight: bold;\n            margin: 0 5px;\n          }\n        }\n      }\n\n      .select-wrapper {\n        width: 100%;\n        .unselect-size {\n          img {\n            opacity: 0.4;\n            transition: opacity 0.2s;\n          }\n        }\n        .select-size {\n          img {\n            opacity: 1;\n          }\n        }\n        .select-size-line {\n          opacity: 0;\n          background-color: var(--sunzi-theme-color);\n          transition: opacity 0.2s;\n        }\n        .select-size-line-show {\n          opacity: 1;\n        }\n      }\n\n      .button-group {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n\n        .disable-button {\n          background: rgba(0, 0, 0, 0.16);\n          pointer-events: none;\n          touch-action: none;\n          cursor: not-allowed;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"related-record-product": `sunzi__related-record-product-IEHcY`,
	"relatedRecordProduct": `sunzi__related-record-product-IEHcY`,
	"related-record-product-drawer": `sunzi__related-record-product-drawer-AnOo8`,
	"relatedRecordProductDrawer": `sunzi__related-record-product-drawer-AnOo8`,
	"drawer-content": `sunzi__drawer-content-hnT8d`,
	"drawerContent": `sunzi__drawer-content-hnT8d`,
	"size": `sunzi__size-GyoTF`,
	"image-wrapper": `sunzi__image-wrapper-IHVBl`,
	"imageWrapper": `sunzi__image-wrapper-IHVBl`,
	"image": `sunzi__image-hwg7t`,
	"offer": `sunzi__offer-vNBVZ`,
	"previous": `sunzi__previous-qXjLn`,
	"title": `sunzi__title-sqYAj`,
	"price": `sunzi__price-OzlrX`,
	"tip-wrapper": `sunzi__tip-wrapper-tGZmL`,
	"tipWrapper": `sunzi__tip-wrapper-tGZmL`,
	"tip": `sunzi__tip-jf0NQ`,
	"price1": `sunzi__price1-ZD6jW`,
	"price2": `sunzi__price2-_8TLN`,
	"select-wrapper": `sunzi__select-wrapper-hLXFy`,
	"selectWrapper": `sunzi__select-wrapper-hLXFy`,
	"unselect-size": `sunzi__unselect-size-w3kxc`,
	"unselectSize": `sunzi__unselect-size-w3kxc`,
	"select-size": `sunzi__select-size-atSO0`,
	"selectSize": `sunzi__select-size-atSO0`,
	"select-size-line": `sunzi__select-size-line-rxu52`,
	"selectSizeLine": `sunzi__select-size-line-rxu52`,
	"select-size-line-show": `sunzi__select-size-line-show-alf4C`,
	"selectSizeLineShow": `sunzi__select-size-line-show-alf4C`,
	"button-group": `sunzi__button-group-jep1l`,
	"buttonGroup": `sunzi__button-group-jep1l`,
	"disable-button": `sunzi__disable-button-HVY4f`,
	"disableButton": `sunzi__disable-button-HVY4f`
};
export default ___CSS_LOADER_EXPORT___;
